import { Component } from '@angular/core';

@Component({
	selector: 'stream-root',
	templateUrl: './app.component.html',
})
export class AppComponent { }
